import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, Route } from 'react-router';
import { AddNetworkPage, EditNetworkPage, NetworksPage } from '#route-bundles/authenticated.tsx';
import { fallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { fromArray, Titled } from '#util/title.ts';

/**
 * {@link networksRootRoute} contains all of the routing config for the /networks path
 */
export const networksRootRoute = (
  <Route
    element={
      <Titled title={(title) => fromArray(['Networks', title])}>
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </Titled>
    }
  >
    <Route index={true} element={<NetworksPage />} />
    <Route path="add" element={<AddNetworkPage />} />
    <Route
      path=":networkId"
      element={
        <ErrorBoundary fallbackRender={fallbackRenderNotFound}>
          <Outlet />
        </ErrorBoundary>
      }
    >
      <Route index={true} element={<EditNetworkPage />} />
    </Route>
  </Route>
);
